import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

// Small uppercase heading used for sections inside the workstation drawers
// (e.g. "Details", "Draft Outreach").
const SectionLabel = ({ text }) => (
	<Typography
		sx={{
			fontSize: '11px',
			fontWeight: 600,
			textTransform: 'uppercase',
			color: 'text.secondary',
			mb: '6px',
		}}
	>
		{text}
	</Typography>
);

SectionLabel.propTypes = {
	text: PropTypes.string.isRequired,
};

export default SectionLabel;
